import Attempts from './Attempts/queries'
const PackageService = {
  Attempts,
}

export default PackageService
